// extracted by mini-css-extract-plugin
module.exports = {"title":"TimelineItemText_title__OVEaf","subtitle":"TimelineItemText_subtitle__PHHAU"};